import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled";
import { Grid, Select, Stack, Typography } from "@mui/material";
import { MeasureDateRange } from "../../../../../../../../../api/types/fieldConfigurationTypes";
import type { Ranges } from "../../../utils/dateRangeToString";

interface Props {
  dateRange?: MeasureDateRange | undefined | null;
  ranges: Ranges;
  onChange: (newDateRangeType: MeasureDateRange) => void;
  disabled: boolean;
}

export const DateRanges = ({ dateRange, ranges, onChange, disabled }: Props) => {
  return (
    <Grid container sx={{ alignItems: "center", width: "100%" }}>
      <Typography>Period</Typography>
      <HorizontalFill />
      <Select
        value={dateRange || MeasureDateRange.NetChange}
        sx={{ width: 208, ".MuiSelect-select": { py: 0.7, alignContent: "center" } }}
        onChange={(evt) => onChange(evt.target.value as MeasureDateRange)}
        disabled={disabled}
      >
        {ranges.map((value) => (
          <MenuItemStyled
            key={value.value}
            value={value.value}
            selected={value.value === dateRange}
            onClick={() => onChange(value.value)}
          >
            <Stack direction="row" sx={{ flex: 1 }}>
              <Typography variant="caption">{value.text}</Typography>
              <HorizontalFill />
              <Typography variant="caption" color="secondary">
                {value.short}
              </Typography>
            </Stack>
          </MenuItemStyled>
        ))}
      </Select>
    </Grid>
  );
};

export default DateRanges;
